(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b18-configurator"] && !Shopify.designMode) return;
  try {
    (function(root){
  const keys=['family','color','coating','material'];
  function forMounting(catalog,mounting){
    if(mounting==='aro_completo')return catalog.slice();
    if(mounting==='ranurado'||mounting==='tres_piezas'||mounting==='clip_sin_montaje')return catalog.filter(v=>v.material==='Airwear');
    return [];
  }
  function startingTotal(catalog,framePrice,mounting){
    const eligible=forMounting(catalog,mounting);
    return eligible.length?framePrice+Math.min(...eligible.map(v=>v.price)):null;
  }
  function resolve(catalog,current,key,value,selection={}){
    const requested={...current,...selection,[key]:value};
    if(key==='family'&&value==='Transparentes')requested.color='';
    if(requested.family==='Transitions'&&current.coating==='Prevencia'&&!Object.hasOwn(selection,'coating'))requested.coating='Natural Look';
    const candidates=catalog.filter(v=>v[key]===value&&(!requested.family||key==='family'||v.family===requested.family));
    const score=v=>keys.reduce((sum,k)=>sum+(requested[k]!==undefined&&v[k]===requested[k]?({family:100,color:20,coating:10,material:5}[k]):0),0);
    candidates.sort((a,b)=>score(b)-score(a)||a.price-b.price||a.id.localeCompare(b.id));
    const variant=candidates[0]||null;
    const changes=variant?keys.filter(k=>k!==key&&!Object.hasOwn(selection,k)&&!(key==='family'&&value==='Transparentes'&&k==='color')&&current[k]!==undefined&&current[k]!==variant[k]).map(k=>({key:k,from:current[k],to:variant[k]})):[];
    return {variant,changes};
  }
  function cheapest(catalog,selection){return catalog.filter(v=>keys.every(k=>selection[k]===undefined||v[k]===selection[k])).sort((a,b)=>a.price-b.price)[0]||null;}
  function eligible(variant,eyes){
    if(!variant?.range||variant.range.some(value=>value===null)||!Array.isArray(eyes)||eyes.length!==2)return false;
    const [positive,negative,cylinder,combined]=variant.range;
    return eyes.every(({sphere,cyl})=>Number.isFinite(sphere)&&Number.isFinite(cyl)&&Number.isInteger(sphere*4)&&Number.isInteger(cyl*4)&&sphere<=positive&&sphere>=negative&&cyl<=0&&cyl>=cylinder&&sphere+cyl>=combined);
  }
  function ormaRecommended(eyes){
    return Array.isArray(eyes)&&eyes.length===2&&eyes.every(eye=>Number.isFinite(eye.sphere)&&eye.sphere>=-1.75&&eye.sphere<=1.75);
  }
  function materialAllowed(variant,eyes){
    return variant.material!=='Orma'||ormaRecommended(eyes);
  }
  function sellable(variant,eyes){
    return eligible(variant,eyes)&&materialAllowed(variant,eyes);
  }
  function readGraduation(draft){
    const read=key=>{const raw=(draft[key]||'').trim().replace(/−/g,'-').replace(',','.');return /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(raw)?Number(raw):NaN};
    const eyes=['right','left'].map(e=>({sphere:read(e+'_sphere'),cyl:read(e+'_cylinder')}));
    return eyes.every(e=>Number.isFinite(e.sphere)&&Number.isFinite(e.cyl)&&Number.isInteger(e.sphere*4)&&Number.isInteger(e.cyl*4))?eyes:null;
  }
  function forGraduation(catalog,eyes){return eyes?catalog.filter(v=>sellable(v,eyes)):catalog.slice()}
  function materialAlternative(catalog,current,eyes){
    if(!current)return null;
    const compatible=catalog.filter(v=>v.family===current.family&&v.color===current.color&&v.coating===current.coating&&sellable(v,eyes));
    for(const material of ['Airwear','T&L']){
      const alternative=cheapest(compatible,{material});
      if(alternative)return alternative;
    }
    return null;
  }
  const api={resolve,cheapest,keys,forMounting,startingTotal,eligible,ormaRecommended,materialAllowed,sellable,readGraduation,forGraduation,materialAlternative};
  if(typeof module!=='undefined')module.exports=api;else root.B18Model=api;
})(typeof window!=='undefined'?window:globalThis);

(() => {
  function start(root) {
    if (root.dataset.started) return;
    const form=root.closest('form'), gpo=form.querySelector('.gpo-app[data-option-set-id="1738945"]');
    if(!gpo)return;
    root.dataset.started='true';
    const data=JSON.parse(root.querySelector('[data-b18-data]').textContent), t=k=>{const value=data.text[k]||k;const txt=document.createElement('textarea');txt.innerHTML=value;return txt.value};
    const flow=root.querySelector('.b18-flow'), total=root.querySelector('.b18-total'), dialog=root.querySelector('dialog');
    const model=window.B18Model, money=n=>new Intl.NumberFormat('es-MX',{style:'currency',currency:data.currency}).format(n);
    const mount=root.dataset.mounting, restricted=['ranurado','tres_piezas'].includes(mount);
    const uploadHost=root.querySelector('.b18-upload-host'), reviewActions=root.querySelector('.b18-review-actions');
    uploadHost.append(gpo.closest('.gpo-container'));
    const clipFrame=!!data.clip;
    const source=data.catalog.filter(v=>!(v.family==='Transitions'&&v.coating==='Prevencia')&&!(clipFrame&&v.family==='Xperio')).map(v=>({...v}));
    const inputs=()=>[...gpo.querySelectorAll('input[gpo-data-variant-id]')];
    const nativeInput=id=>inputs().find(e=>e.getAttribute('gpo-data-variant-id')===String(id));
    for(const v of source){
      const input=nativeInput(v.id), addon=input?.closest('.gpo-ov-item')?.querySelector('.addOn');
      const raw=addon?.textContent.replace(/[^0-9.]/g,'');
      v.linked=!!input;v.online=(data.saleIds||[]).some(id=>String(id)===v.id);
      const days=data.delivery?.[v.id];v.deliveryDays=Number.isInteger(days)&&days>0?days:null;
      if(raw&&Number.isFinite(Number(raw))&&Number(raw)>0)v.price=Number(raw);
    }
    const catalog=model.forMounting(source,mount);
    let state={},variant=null,step='purchase',editing=false,editReturn='summary',editChoices={},pending=null,pendingReason=null,rx=null,rxDraft={},rxValid=false,rxExpanded=true;
    let frame=data.variants.find(v=>String(v.id)===String(data.selected)),lastFrame=String(frame?.id),canBuy=false;
    const swatches={Gris:'#707875','Café':'#815b43',Verde:'#596e55','Índigo':'#454e8b',Amatista:'#9b7da5','Ámbar':'#d3a14f','Rubí':'#9d394b'};
    const framePrice=()=>Number(frame?.price||0)/100;
    const prop=name=>form.querySelector('.gpo-hidden-inputs input[data-field-name="'+name+'"]');
    const hasRecipe=()=>{const p=prop('Receta');return !!p&&!p.disabled&&!!p.value&&p.hasAttribute('name')};
    const setPurchase=graduated=>{
      const target=[...gpo.querySelectorAll('input[data-field-name="Tipo de compra"]')].find(i=>i.value===(graduated?'Armazón + graduación':'Comprar solo armazón'));
      if(target&&!target.checked)target.click();
    };
    function syncVariant(){
      if(state.purchase!=='graduated'){setPurchase(false);return}
      setPurchase(true);
      const input=variant&&nativeInput(variant.id);
      if(input&&!input.disabled&&!input.checked)input.click();
    }
    function el(tag,cls,text){const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e}
    function button(label,fn,cls='b18-primary'){const b=el('button',cls,label);b.type='button';b.onclick=fn;return b}
    function info(text){flow.append(el('div','b18-info',text))}
    function heading(key,help){const h=el('h2','b18-step-title',t(key));h.tabIndex=-1;flow.append(h);if(help)flow.append(el('p','',t(help)))}
    function progress(){
      if(state.purchase!=='graduated'||['purchase','help'].includes(step))return;
      const active=step==='graduation'?0:step==='recipe'?2:step==='summary'?3:1;
      const list=el('ol','b18-progress');list.setAttribute('aria-label',t('progress_label'));
      ['progress_start','progress_lenses','progress_recipe','progress_review'].forEach((key,index)=>{
        const item=el('li',index<active?'is-complete':index===active?'is-current':'');
        if(index===active)item.setAttribute('aria-current','step');
        const track=el('span','b18-progress-track');track.setAttribute('aria-hidden','true');
        item.append(track,el('span','',t(key)));list.append(item);
      });
      flow.append(list);
      if(editing)flow.append(el('p','b18-progress-edit',t('progress_edit')));
    }
    function deliveryText(v){return v?.deliveryDays?t('delivery')+': '+v.deliveryDays+' '+t(v.deliveryDays===1?'business_day':'business_days'):t('delivery_pending')}
    function card(title,desc,fn,cost='',selected=false,swatch=''){
      const b=button('',fn,'b18-card');b.setAttribute('aria-label',title);b.setAttribute('aria-pressed',String(selected));
      if(swatch){const dot=el('span','b18-swatch');dot.style.background=swatch;dot.setAttribute('aria-hidden','true');b.append(dot)}
      const text=el('span');text.append(el('strong','',title));if(desc)text.append(el('small','',desc));b.append(text);
      if(cost)b.append(el('span','b18-cost',cost));return b;
    }
    function cards(items,color=false){const box=el('div','b18-cards'+(color?' b18-colors':''));for(const a of items)box.append(card(...a));flow.append(box)}
    function glassesVisual(style){
      const visual=el('span','b18-glasses b18-glasses-'+style);visual.setAttribute('aria-hidden','true');
      visual.innerHTML='<svg viewBox="0 0 220 112" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="110" cy="97" rx="79" ry="5" fill="#202422" opacity=".05"/><g stroke-linecap="round" stroke-linejoin="round"><path d="M24 34 10 25M196 34l14-9" class="b18-temples"/><path d="M28 30C43 23 73 23 91 32c7 4 8 11 5 22-4 15-12 29-27 32-18 4-36-8-41-29-3-11-5-23 0-27Z" class="b18-lens"/><path d="M192 30c-15-7-45-7-63 2-7 4-8 11-5 22 4 15 12 29 27 32 18 4 36-8 41-29 3-11 5-23 0-27Z" class="b18-lens"/><path d="M97 41c8-7 18-7 26 0M91 29c12-5 26-5 38 0" class="b18-bridge"/><path d="M38 53q18-15 43-13M139 53q18-15 43-13" class="b18-reflection"/><path d="m38 36-3 15m137-16-4 12" stroke="#fff" stroke-width="3" opacity=".48"/></g></svg>';
      return visual;
    }
    function visionCard(progressive){
      const b=card(t(progressive?'progressive':'single'),t(progressive?'progressive_help':'single_help'),()=>go(progressive?'help':'family'));
      b.classList.add('b18-visual-card');
      const visual=el('span','b18-vision-visual'+(progressive?' b18-vision-progressive':''));visual.setAttribute('aria-hidden','true');
      const gradientId=form.getAttribute('id')+'-vision-'+(progressive?'progressive':'single');
      visual.innerHTML='<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><defs><radialGradient id="'+gradientId+'" cx="35%" cy="28%" r="80%"><stop offset="0" stop-color="#fff"/><stop offset=".65" stop-color="#f2f5f6"/><stop offset="1" stop-color="#dce3e5"/></radialGradient></defs><ellipse cx="60" cy="109" rx="39" ry="4" fill="#202422" opacity=".06"/><circle cx="62" cy="57" r="45" fill="#e3e9eb" stroke="#a2afb4" stroke-width="1.6"/><circle cx="59" cy="55" r="45" fill="url(#'+gradientId+')" stroke="#a2afb4" stroke-width="1.6"/><path class="b18-vision-middle" d="M34 21Q59 14 84 21L70 83Q59 90 48 83Z" fill="#a7b9bf" opacity=".14"/><path class="b18-vision-middle" d="M27 82Q59 67 91 82" fill="none" stroke="#a7b9bf" stroke-width="1.2" stroke-dasharray="2 4"/><path d="M25 44Q32 25 50 20" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round"/><path d="M39 97Q66 108 88 88" fill="none" stroke="#fff" stroke-width="1.5" opacity=".7"/></svg>';
      b.prepend(visual);b.querySelector('strong').parentElement.append(el('span','b18-vision-label',t(progressive?'progressive_distances':'single_distance')));
      return b;
    }
    function featureIcon(name){
      const paths={lenses:'<circle cx="12" cy="12" r="8"/><path d="M7 9c1-2 3-3 5-3"/>',material:'<path d="m3 8 9-5 9 5-9 5-9-5Zm0 5 9 5 9-5M3 18l9 5 9-5"/>',color:'<path d="M12 3c-3 4-7 8-7 12a7 7 0 0 0 14 0c0-4-4-8-7-12Z"/>',coating:'<path d="m12 3 2.4 6.6L21 12l-6.6 2.4L12 21l-2.4-6.6L3 12l6.6-2.4L12 3Z"/>',recipe:'<path d="M6 3h8l4 4v14H6V3Zm8 0v5h4M9 12h6M9 16h6"/>',delivery:'<path d="M3 6h11v11H3V6Zm11 5h4l3 4v2h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>'};
      const span=el('span','b18-feature-icon');span.setAttribute('aria-hidden','true');span.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">'+(paths[name]||paths.lenses)+'</svg>';return span;
    }
    function materialVisual(material){
      const width={Orma:25,Airwear:16,'T&L':11}[material]||16;
      const visual=el('span','b18-material-visual');visual.setAttribute('aria-hidden','true');
      visual.innerHTML='<svg viewBox="0 0 110 120" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="55" cy="111" rx="26" ry="4" fill="#202422" opacity=".05"/><path d="M'+(55-width/2)+' 13Q'+(35-width/2)+' 59 '+(55-width/2)+' 106L'+(55+width/2)+' 106Q'+(35+width/2)+' 59 '+(55+width/2)+' 13Z" fill="#e7eef0" stroke="#819497" stroke-width="1.5"/><path d="M'+(57-width/2)+' 23Q'+(41-width/2)+' 59 '+(57-width/2)+' 96" stroke="#fff" stroke-width="3" stroke-linecap="round"/><path d="M'+(55-width/2)+' 13h'+width+'M'+(55-width/2)+' 106h'+width+'" stroke="#57777d" stroke-width="1.5"/></svg>';
      return visual;
    }
    function selectionPreview(){
      const box=el('div','b18-selection-preview'),top=el('h2','b18-selection-title',t('your_selection'));flow.append(top);
      const selection={...state};
      if(!selection.material){const materials=[...new Set(candidate(state).map(v=>v.material))];if(materials.length===1)selection.material=materials[0]}
      const fields=el('div','b18-summary-features');
      for(const [key,icon] of [['family','lenses'],['color','color'],['material','material'],['coating','coating']]){
        if(!selection[key])continue;
        const editable=key!==step&&!(key==='coating'&&selection.family==='Xperio')&&!(key==='material'&&!state.coating);
        summaryFeature(fields,key,t(selection[key]),icon,editable?key:null,'',key==='color'?swatches[selection.color]:'');
      }
      box.append(fields);
      if(selection.material==='Airwear'&&['Índigo','Amatista','Ámbar','Rubí'].includes(selection.color))box.append(el('small','',t('airwear_only')));
      if(rx&&mount==='aro_completo'&&!model.ormaRecommended(rx)&&selection.material==='Airwear'&&new Set(candidate(state).map(v=>v.material)).size===1)box.append(el('small','',t('rx_orma_filter')));
      if(rx&&selection.material==='T&L'&&!catalog.some(v=>v.family===selection.family&&v.color===selection.color&&v.coating===selection.coating&&v.material==='Airwear'&&eligible(v,rx)))box.append(el('small','',t('rx_tl_filter')));
      if(mount==='clip_sin_montaje')box.append(el('small','',t('clip_mount_help')));
      flow.append(box);
    }
    function coatingHelp(coating){return t(coating==='Prevencia'?'prevencia_short':coating==='Natural Look'?'natural_short':coating==='Sin antirreflejante'?'no_coating_short':'optikot_short')}
    function summaryFeature(box,key,value,iconName,edit,help='',swatch=''){
      const cell=el('div','b18-summary-feature'),top=el('div','b18-feature-top');top.append(featureIcon(iconName),el('small','',t(key)));
      cell.dataset.feature=key;
      if(edit){const b=button(t('change'),()=>beginEdit(edit),'b18-link');b.setAttribute('aria-label',t('change')+' '+t(key).toLowerCase());top.append(b)}
      cell.append(top);const label=el('strong','',value);
      if(swatch){const dot=el('span','b18-swatch');dot.style.background=swatch;dot.setAttribute('aria-hidden','true');label.prepend(dot)}
      cell.append(label);if(help)cell.append(el('small','b18-feature-help',help));box.append(cell);
    }
    function purchaseSummary(){
      const box=el('article','b18-purchase-summary'),header=el('div','b18-summary-product');
      const imageUrl=frame.featured_image?.src||data.frameImage;
      if(imageUrl){const img=el('img','b18-summary-photo');img.src=imageUrl;img.alt=data.title+' · '+frame.title;img.width=120;img.height=100;header.append(img)}
      const copy=el('div');copy.append(el('strong','',data.title));
      const values=frame.options||[frame.option1,frame.option2,frame.option3].filter(Boolean);
      const details=(data.options||[]).map((name,i)=>values[i]?name+' '+values[i]:'').filter(Boolean).join(' · ');
      copy.append(el('small','',details||frame.title));header.append(copy);box.append(header);
      if(variant){
        const grid=el('div','b18-summary-features');
        summaryFeature(grid,'family',t(variant.family),'lenses','family',t(variant.family==='Transitions'?'trans_help':variant.family==='Xperio'?'sun_help':'clear_help'));
        if(variant.color)summaryFeature(grid,'color',t(variant.color),'color','color','',swatches[variant.color]);
        summaryFeature(grid,'material',t(variant.material),'material','material');
        summaryFeature(grid,'coating',t(variant.coating),'coating',variant.family==='Xperio'?null:'coating',coatingHelp(variant.coating));
        box.append(grid);
        const recipe=el('div','b18-summary-recipe');summaryFeature(recipe,'rx',hasRecipe()?t('recipe_attached'):t('rx_pending'),'recipe','recipe',t('recipe_review'));box.append(recipe);
      }else box.append(el('p','',t('frame_only_help')));
      const prices=el('div','b18-summary-prices');for(const [label,value] of [[t('frame'),framePrice()],...(variant?[[t('lenses'),variant.price]]:[])]){const line=el('div');line.append(el('span','',label),el('strong','',money(value)));prices.append(line)}
      box.append(prices);flow.append(box);
    }
    function materialNext(){
      delete state.material;const available=candidate(state),materials=[...new Set(available.map(v=>v.material))];
      if(materials.length===1){state.material=materials[0];variant=model.cheapest(available,{});syncVariant();go('recipe')}else go('material');
    }
    function familyCard(family,description){
      const b=card(t(family),t(description),()=>pick('family',family),'',state.family===family);
      b.classList.add('b18-family-card');
      const visual=glassesVisual(family.toLowerCase());
      b.prepend(visual);
      if(clipFrame&&family==='Transitions'){b.querySelector('strong').textContent=t(family)+'*';b.querySelector('strong').parentElement.append(el('small','b18-clip-note',t('clip_transitions_note')))}
      if(family!=='Transparentes'){
        const colors=Object.keys(swatches).filter(color=>currentCatalog().some(v=>v.family===family&&v.color===color));
        const palette=el('span','b18-mini-palette');palette.setAttribute('role','img');palette.setAttribute('aria-label',t('available_colors')+': '+colors.map(t).join(', '));
        for(const color of colors){const dot=el('span');dot.style.background=swatches[color];dot.title=t(color);dot.setAttribute('aria-hidden','true');palette.append(dot)}
        b.querySelector('strong').parentElement.append(palette);
      }
      return b;
    }
    function go(next){step=next;render();flow.querySelector('.b18-step-title')?.focus({preventScroll:true})}
    function helpLink(label='contact'){
      const a=el('a',label==='contact'?'b18-primary b18-advice':'b18-link',t(label)),intro=label==='availability'?'message_store':step==='help'?'message_progressive':'message_intro';
      const details=[t(intro),data.title+' · '+frame.title];
      if(variant)details.push([t(variant.family),t(variant.color),t(variant.material),t(variant.coating)].filter(Boolean).join(' · '));
      details.push(data.productUrl);a.href=data.contact+'?text='+encodeURIComponent(details.join('\n'));a.target='_blank';a.rel='noopener';flow.append(a);
    }
    function eligible(v,eyes){
      return model.sellable(v,eyes);
    }
    function currentCatalog(){return ['recipe','graduation'].includes(step)?catalog:model.forGraduation(catalog,rx)}
    function candidate(selection,omit){return currentCatalog().filter(v=>model.keys.every(k=>k===omit||selection[k]===undefined||v[k]===selection[k]))}
    function restoreSelection(){if(variant)state={...state,...Object.fromEntries(model.keys.map(k=>[k,variant[k]]))};editChoices={}}
    function beginEdit(next){if(!editing)editReturn=step==='summary'?'summary':'recipe';editing=!!variant;editChoices={};go(next)}
    function commit(v){variant=v;rxValid=!!rx&&eligible(v,rx);restoreSelection();syncVariant();const target=editing?editReturn:'recipe';editing=false;go(target)}
    function propose(v,reason=null,selectedKey=null){
      pending=v;pendingReason=reason;const box=root.querySelector('.b18-comparison');box.replaceChildren();
      const prescriptionChange=!selectedKey,title=t(prescriptionChange?'rx_change_title':'change_title');
      dialog.querySelector('h2').textContent=title;dialog.setAttribute('aria-label',title);
      dialog.querySelector('[data-keep]').textContent=t(reason?'edit_rx':'keep');
      root.querySelector('.b18-change-reason').textContent=(reason?t(reason)+' ':v.family==='Transitions'&&variant.coating==='Prevencia'?t('trans_natural_help')+' ':v.family==='Transitions'&&['Índigo','Amatista','Ámbar','Rubí'].includes(v.color)&&v.material!==variant.material?t('airwear_only')+' ':'')+t('changes_help');
      const highlightKey=selectedKey||model.keys.find(key=>v[key]!==variant[key])||'material';
      for(const [label,candidate] of [['current',variant],['proposed',v]]){
        const a=el('article'),specs=el('div','b18-comparison-specs');a.dataset.comparison=label;specs.append(el('b','b18-comparison-badge b18-comparison-'+label,t(label==='proposed'&&prescriptionChange?'recommended':label)));
        const details=[{keys:['family','color'],value:[t(candidate.family),t(candidate.color)].filter(Boolean).join(' ')},{keys:['material'],value:t(candidate.material)},{keys:['coating'],value:t(candidate.coating)}];
        for(const detail of details){const line=el('div','b18-comparison-detail'),changed=label==='proposed'&&detail.keys.some(key=>candidate[key]!==variant[key]);line.append(el('span',changed?'b18-change-value':'',detail.value));if(label==='proposed'&&detail.keys.includes(highlightKey))line.append(el('small','b18-change-selection',t(prescriptionChange?'rx_recommendation':'your_selection')));specs.append(line)}
        a.append(specs,el('p','',t('process_lenses')));
        a.append(el('strong','',money(framePrice()+candidate.price)));box.append(a);
        a.append(el('p','',deliveryText(candidate)));
      }
      dialog.showModal();dialog.querySelector('[data-keep]').focus();
    }
    function pick(key,value){
      if(editing&&variant){
        if(key==='family'&&value!=='Transparentes'){editChoices={family:value};state.family=value;delete state.color;go('color');return}
        const result=model.resolve(currentCatalog(),variant,key,value,editChoices);
        if(!result.variant){info(t('rx_unavailable'));return}
        if(result.changes.length){propose(result.variant,null,key);return}
        commit(result.variant);return;
      }
      state[key]=value;rxValid=false;
      if(key==='family'){delete state.color;delete state.coating;delete state.material;variant=null;if(value==='Transparentes')state.color='';go(value==='Transparentes'?'coating':'color')}
      if(key==='color'){delete state.coating;delete state.material;variant=null;if(state.family==='Xperio'){state.coating='Optikot';materialNext()}else go('coating')}
      if(key==='coating')materialNext();
      if(key==='material'){variant=model.cheapest(currentCatalog(),state);if(!variant){info(t('rx_unavailable'));return}syncVariant();go('recipe')}
    }
    function row(box,key,value,edit){
      const r=el('div','b18-row'), d=el('div');d.append(el('small','',t(key)),document.createTextNode(value));r.append(d);
      if(edit){const b=button(t('change'),()=>{editing=true;go(edit)},'b18-link');b.setAttribute('aria-label',t('change')+' '+t(key).toLowerCase());r.append(b)}box.append(r);
    }
    function rxForm(){
      const grid=el('div','b18-rx-grid');
      for(const eye of ['right','left']){
        const field=el('fieldset');field.append(el('legend','',t(eye)));
        for(const kind of ['sphere','cylinder']){
          const key=eye+'_'+kind,id=form.getAttribute('id')+'-b18-'+key, input=el('select');input.id=id;
          const placeholder=el('option','',t('select_value'));placeholder.value='';input.append(placeholder);
          const ranges=(step==='graduation'?catalog:candidate(state)).map(v=>v.range).filter(Boolean);
          const minimum=kind==='sphere'?Math.min(...ranges.map(r=>r[1])):Math.min(...ranges.map(r=>r[2]));
          const maximum=kind==='sphere'?Math.max(...ranges.map(r=>r[0])):0;
          const quarters=[];
          if(minimum<=0&&maximum>=0)quarters.push(0);
          for(let quarter=Math.min(-1,maximum*4);quarter>=minimum*4;quarter--)quarters.push(quarter);
          for(let quarter=Math.max(1,minimum*4);quarter<=maximum*4;quarter++)quarters.push(quarter);
          for(const quarter of quarters){
            const value=(quarter/4).toFixed(2), label=(quarter>0?'+':'')+value;
            const option=el('option','',label);option.value=value;input.append(option);
          }
          if(rxDraft[key]&&!Array.from(input.options).some(option=>option.value===rxDraft[key])){
            const option=el('option','',rxDraft[key]);option.value=rxDraft[key];input.append(option);
          }
          input.value=rxDraft[key]||'';
          input.onchange=()=>{rxDraft[key]=input.value;rx=null;rxValid=false;canBuy=false;form.dataset.b18Ready='false'};
          const label=el('label','',t(kind));label.htmlFor=id;field.append(label,input);
        }grid.append(field);
      }flow.append(grid);
    }
    function graduationSummary(){
      const box=el('div','b18-graduation-summary');
      box.append(el('strong','',t('captured_graduation')));
      for(const [i,eye] of ['right','left'].entries()){
        const value=n=>(n>0?'+':'')+n.toFixed(2),line=el('p');
        line.append(el('b','',t(eye)+': '),document.createTextNode(t('sphere')+' '+value(rx[i].sphere)+' · '+t('cylinder')+' '+value(rx[i].cyl)));box.append(line);
      }
      box.append(button(t('change_graduation'),()=>{rxExpanded=true;go('recipe')},'b18-link'));flow.append(box);
    }
    function captureGraduation(){
      const eyes=model.readGraduation(rxDraft);
      if(!eyes){info(t('rx_invalid'));return}
      rx=eyes;rxValid=false;canBuy=false;form.dataset.b18Ready='false';
      if(!model.forGraduation(catalog.filter(v=>v.linked&&v.online),eyes).length){info(t('early_rx_unavailable'));helpLink();return}
      state={purchase:'graduated'};variant=null;editChoices={};editing=false;rxExpanded=false;go('vision');
    }
    function validateRx(){
      editReturn='summary';
      const eyes=model.readGraduation(rxDraft);
      if(!eyes){info(t('rx_invalid'));return}
      rx=eyes;rxValid=false;canBuy=false;form.dataset.b18Ready='false';
      const matching=catalog.filter(v=>model.keys.every(k=>v[k]===state[k])&&eligible(v,eyes));
      const suitable=model.cheapest(matching,{});
      if(!suitable){
        const alternative=model.materialAlternative(catalog.filter(v=>v.linked&&v.online),variant,eyes);
        if(alternative){editing=true;propose(alternative,!model.materialAllowed(variant,eyes)?'orma_sphere_help':'material_range_help');return}
        editing=false;go('summary');return;
      }
      if(!hasRecipe()){info(t('rx_pending'));return}
      rx=eyes;rxValid=true;
      if(suitable.id!==variant.id){editing=true;propose(suitable);return}
      syncVariant();editing=false;go('summary');
    }
    function updateReady(){
      canBuy=step==='summary'&&!!frame?.available&&(state.purchase==='frame'||(!!variant?.linked&&variant.online&&rxValid&&eligible(variant,rx)&&hasRecipe()&&nativeInput(variant.id)?.checked));
      form.dataset.b18Ready=String(canBuy);
    }
    function render(){
      flow.replaceChildren();reviewActions.replaceChildren();root.dataset.step=step;form.dataset.b18Step=step;uploadHost.hidden=step!=='recipe';uploadHost.setAttribute('aria-hidden',String(step!=='recipe'));
      if(step!=='purchase')flow.append(button('← '+t(editing?(editReturn==='recipe'?'edit_rx':'back_summary'):'back'),()=>{
        if(editing){restoreSelection();editing=false;go(editReturn);return}
        const materialCount=new Set(candidate(state,'material').map(v=>v.material)).size;
        const previous={graduation:'purchase',vision:'graduation',family:'vision',color:'family',coating:state.family==='Transparentes'?'family':'color',material:state.family==='Xperio'?'color':'coating',recipe:materialCount>1?'material':state.family==='Xperio'?'color':'coating',summary:state.purchase==='frame'?'purchase':'recipe',help:'vision'};
        go(previous[step]||'purchase');
      },'b18-link'));
      progress();
      if(step==='purchase'){
        heading('purchase');const options=[],start=model.startingTotal(source,framePrice(),mount);
        if(start!==null&&data.currency==='MXN')options.push([t('graduated'),t('pair_included'),()=>{state={purchase:'graduated'};variant=null;editing=false;editChoices={};setPurchase(true);go('graduation')},t('from')+' '+money(start)]);
        options.push([t('frame_only'),t('frame_only_help'),()=>{state={purchase:'frame'};variant=null;rxValid=false;setPurchase(false);go('summary')},money(framePrice())]);cards(options);
        if(restricted)info(t('restricted_mount'));if(mount==='clip_sin_montaje')info(t('clip_mount_help'));if(start===null)info(t(mount==='careta'?'shield_mount':'unknown_mount'));if(data.currency!=='MXN')info(t('currency'));helpLink('availability');
      }
      if(step==='graduation'){
        heading('early_rx_title','early_rx_help');flow.append(el('p','',t('rx_numbers_help')));rxForm();
        flow.append(button(t('continue'),captureGraduation));
        flow.append(button(t('skip_graduation'),()=>{state={purchase:'graduated'};variant=null;editChoices={};editing=false;rx=null;rxDraft={};rxValid=false;rxExpanded=true;go('vision')},'b18-secondary'));helpLink('rx_outside');
      }
      if(step==='vision'){heading('vision');if(rx)flow.append(el('p','b18-inline-note',t('early_rx_guided')));const choices=el('div','b18-cards');choices.append(visionCard(false),visionCard(true));flow.append(choices)}
      if(step==='help'){heading('help','help_text');helpLink()}
      if(step==='family'){
        heading('family_title','intro');const desc={Transparentes:'clear_help',Transitions:'trans_help',Xperio:'sun_help'};
        if(clipFrame)flow.append(el('p','b18-inline-note',t('clip_family_help')));
        const choices=el('div','b18-cards');for(const f of ['Transparentes','Transitions','Xperio'].filter(f=>currentCatalog().some(v=>v.family===f)))choices.append(familyCard(f,desc[f]));flow.append(choices);
      }
      if(step==='color'){
        heading('color_title',state.family==='Transitions'?'transition_color_help':'solar_color_help');if(state.family==='Transitions')flow.append(el('p','b18-inline-note',t('trans_coating_help')));const colors=['Gris','Café','Verde','Índigo','Amatista','Ámbar','Rubí'].filter(c=>currentCatalog().some(v=>v.family===state.family&&v.color===c));
        cards(colors.map(c=>[t(c),state.family==='Transitions'&&['Índigo','Amatista','Ámbar','Rubí'].includes(c)?t('airwear_only'):'',()=>pick('color',c),'',state.color===c,swatches[c]]),true);
      }
      if(step==='coating'){
        selectionPreview();heading('coating_title','coating_help');const options=currentCatalog().filter(v=>v.family===state.family&&v.color===state.color);
        if(state.family==='Transitions')flow.append(el('p','b18-inline-note',t('trans_coating_help')));
        const choices=el('div','b18-cards');
        for(const c of ['Prevencia','Natural Look','Sin antirreflejante'].filter(c=>options.some(v=>v.coating===c))){
          const matches=options.filter(v=>v.coating===c),best=model.cheapest(matches,{});
          const choice=card(t(c),'',()=>pick('coating',c),'',state.coating===c);choice.classList.add('b18-visual-card');
          choice.prepend(glassesVisual(c==='Prevencia'?'prevencia':c==='Sin antirreflejante'?'uncoated':'natural-look'));
          const copy=choice.querySelector('strong').parentElement;copy.append(el('small','',coatingHelp(c)));if(c!=='Sin antirreflejante')copy.append(el('small','b18-reflection-note',t('reflection_preview')));copy.append(el('span','b18-coating-price',t('from')+' '+money(framePrice()+best.price)));
          choices.append(choice);
        }flow.append(choices);
      }
      if(step==='material'){
        selectionPreview();heading('material_title','thickness_help');const materials=['Orma','Airwear','T&L'].filter(m=>currentCatalog().some(v=>v.material===m&&v.family===state.family&&v.coating===state.coating&&(editing||v.color===state.color)));
        if(rx)flow.append(el('p','b18-inline-note',t(!model.ormaRecommended(rx)?'rx_orma_filter':'rx_options_filter')));
        const choices=el('div','b18-cards');for(const m of materials){const v=model.cheapest(currentCatalog(),{...state,material:m});const choice=card(t(m),v?t('material_'+(m==='T&L'?'tl':m.toLowerCase())):t('requires_changes'),()=>pick('material',m),'',state.material===m);choice.classList.add('b18-material-card');choice.prepend(materialVisual(m));const copy=choice.querySelector('strong').parentElement;if(m==='Orma'&&v)copy.append(el('small','',t('orma_material_help')));copy.append(el('span','b18-coating-price',v?money(framePrice()+v.price):t('see_changes')));choices.append(choice)}flow.append(choices);
      }
      if(step==='recipe'){
        selectionPreview();heading('rx_title','rx_help');if(restricted)info(t('restricted_mount'));
        if(rx&&!rxExpanded)graduationSummary();else{flow.append(el('p','',t('rx_numbers')),el('p','',t('rx_numbers_help')));rxForm()}
        helpLink('rx_outside');
        if(hasRecipe())info(t('uploaded'));
        reviewActions.append(button(t('review'),validateRx));
      }
      if(step==='summary'){
        heading('summary','summary_subtitle');purchaseSummary();flow.append(el('p','b18-summary-note',t(variant?'buy_ready':'buy_frame_ready')));
        if(variant){
          const combinations=candidate(state),unknown=combinations.some(v=>!v.range||v.range.some(x=>x===null));
          const issue=rx&&!model.materialAllowed(variant,rx)?'orma_sphere_blocked':!rxValid?(rx?(unknown?'range_pending':'rx_unavailable'):'need_review'):!hasRecipe()?'rx_pending':!variant.online||!variant.linked?'not_connected':null;
          if(issue){info(t(issue));if(['orma_sphere_blocked','range_pending','rx_unavailable','not_connected'].includes(issue))helpLink()}
        }
        if(!frame?.available)info(t('frame_unavailable'));
        flow.append(button(t('restart'),()=>{state={};variant=null;rx=null;rxDraft={};rxExpanded=true;rxValid=false;editing=false;editChoices={};setPurchase(false);go('purchase')},'b18-link'));
      }
      if(['vision','family','color','coating','material'].includes(step))helpLink('help_short');
      total.replaceChildren();const caption=el('div');caption.append(el('small','',t('total')));total.append(caption,el('strong','',money(framePrice()+(variant?.price||0))));
      const delivery=root.querySelector('.b18-delivery');delivery.replaceChildren();delivery.hidden=!variant;
      if(variant){const label=el('div','b18-delivery-label');label.append(featureIcon('delivery'),el('strong','',deliveryText(variant)));delivery.append(label,el('p','',t('delivery_note')))}
      const context=form.closest('[data-section-type="product"]')||form.closest('.product-single__meta');
      if(context){const badge=context.querySelector('[data-save-price]');if(badge)badge.hidden=!!variant;const compare=context.querySelector('[data-product-price-wrap]');if(compare)compare.hidden=!!variant;}
      updateReady();
    }
    function cancelProposal(){const target=pendingReason?'recipe':editReturn;pending=null;pendingReason=null;restoreSelection();editing=false;go(target)}
    dialog.querySelector('[data-keep]').onclick=()=>{dialog.close();cancelProposal()};
    dialog.querySelector('[data-accept]').onclick=()=>{const next=pending,needsRecipe=!!pendingReason&&!hasRecipe();pending=null;pendingReason=null;dialog.close();if(needsRecipe)editing=false;if(next)commit(next)};
    dialog.addEventListener('cancel',cancelProposal);
    form.addEventListener('click',e=>{if(e.target.closest('[name="add"]')&&!canBuy){e.preventDefault();e.stopImmediatePropagation();info(t('need_review'))}},true);
    form.addEventListener('submit',e=>{updateReady();if(!canBuy){e.preventDefault();e.stopImmediatePropagation();info(t('need_review'))}},true);
    setInterval(()=>{
      if(!root.isConnected)return;
      const selected=form.querySelector('[name="id"]')?.value;
      if(selected&&selected!==lastFrame){const next=data.variants.find(v=>String(v.id)===selected);if(next){frame=next;lastFrame=selected;render()}}
      updateReady();
    },500);
    render();
  }
  function scan(){document.querySelectorAll('[data-b18-config]').forEach(start)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  const observer=new MutationObserver(scan);observer.observe(document.documentElement,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
